import { createBrowserRouter } from 'react-router-dom'
import { Dashboard } from 'pages/home/Dashboard'
import { CreateTender } from 'pages/tender/create-tender'
import { EditTenderPage } from 'pages/tender/edit-tender'
import { ProcurementPlans } from 'pages/procurement-plans'
import { CreateProcurementPlan } from 'pages/procurement-plans/create-procurement-plan'
import { ViewProcurementPlanPage } from 'pages/procurement-plans/view-procurement-plan'
import { EditProcurementPlanPage } from 'pages/procurement-plans/edit-procurement-plan'
import { Tenders } from 'pages/tender/tenders-page'
import { Settings } from 'pages/settings'
import { VideoInstructions } from 'pages/video-instructions'
import { Contracts } from 'pages/contracts'
import { Notification } from 'pages/notification'
import { TenderSearch } from 'pages/tender-search'
import { LotEditPage } from 'pages/tender/lot/lot-edit'
import { TenderCommittee } from 'pages/tender-committee'
import { ManagementDashboard } from 'pages/management-dashboard'
import { TenderParticipationPage } from 'pages/tender-participation/tender-participation'
import { TenderParticipationLotPage } from 'pages/tender-participation/lots/tender-participation-lot'
import { News } from 'pages/purchase-pages/news'
import { Reports } from 'pages/purchase-pages/reports'
import { Faq } from 'pages/purchase-pages/faq'
import { Instructions } from 'pages/purchase-pages/instructions'
import { AzeriCard } from './REMOVE_azericard/azericard'
import { Contact } from 'pages/purchase-pages/contact'
import { Competitions } from 'pages/purchase-pages/competitions'
import { CompetitionDetail } from 'pages/purchase-pages/competition-detail'
import { PurchasePlans } from 'pages/purchase-pages/purchase-plans'
import { PurchasePlansDetail } from 'pages/purchase-pages/purchase-plan-detail'
import { ConcludedContracts } from 'pages/purchase-pages/concluded-contracts'
import { Notifications } from 'pages/purchase-pages/notifications'
import { CompetitionProductDetail } from 'pages/purchase-pages/competition-product-detail'
import { Faq as FaqPortal } from 'pages/faq/index'
import { Reports as ReportsPortal } from 'pages/reports/index'
import { News as NewsPortal } from 'pages/news/index'
import { CreateEditNews } from 'pages/news/create-edit-news'
import { CommissionEvaluationDetailsPage } from 'pages/tender-committee/comission-evaluation-details'
import ProtectedRoute from './protected-route'
import { EOrganizationType, EUserRoles } from 'types/users'
import { ProcurementCommittee } from 'pages/procurement-commiittee'
import { CommitteeEvaluationDetailsPage } from 'pages/procurement-commiittee/committee-evaluation-details'
import { Organizations } from 'pages/organizations'

export const appRouter = createBrowserRouter([
  //Public Routes
  {
    path: '/',
    element: <Competitions />,
  },
  {
    path: '/competitions',
    element: <Competitions />,
  },
  {
    path: '/competitions/:id',
    element: <CompetitionDetail />,
  },
  {
    path: '/competitions/products/:id',
    element: <CompetitionProductDetail />,
  },
  {
    path: '/purchase-plans',
    element: <PurchasePlans />,
  },
  {
    path: '/purchase-plans/:id',
    element: <PurchasePlansDetail />,
  },
  {
    path: '/concluded-contracts',
    element: <ConcludedContracts />,
  },
  {
    path: '/notifications',
    element: <Notifications />,
  },
  {
    path: '/news/:id?',
    element: <News />,
  },
  {
    path: '/reports',
    element: <Reports />,
  },
  {
    path: '/faq',
    element: <Faq />,
  },
  // {
  //   path: '/instructions',
  //   element: <Instructions />,
  // },
  {
    path: '/contact',
    element: <Contact />,
  },
  //   Tender Routes
  {
    path: '/portal',
    element: <Dashboard />,
  },
  {
    path: '/portal/tenders',
    element: <Tenders />,
  },
  {
    path: '/portal/tenders/create',
    element: <CreateTender />,
  },
  {
    path: '/portal/tenders/:id/edit',
    element: <EditTenderPage />,
  },
  {
    path: '/portal/tenders/:tenderId/lot/:lotId/edit',
    element: <LotEditPage />,
  },
  {
    path: '/portal/procurement-plans',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.PROCUREMENT_SPECIALIST, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <ProcurementPlans />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/procurement-plans/new',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.PROCUREMENT_SPECIALIST, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <CreateProcurementPlan />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/procurement-plans/:procurementId/edit',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.PROCUREMENT_SPECIALIST, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <EditProcurementPlanPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/procurement-plans/:procurementId/view',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.PROCUREMENT_SPECIALIST, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <ViewProcurementPlanPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/tender-search',
    element: <TenderSearch />,
  },
  {
    path: '/portal/contracts',
    element: <Contracts />,
  },
  {
    path: '/portal/tender-participation/:tenderId',
    element: <TenderParticipationPage />,
  },
  {
    path: '/portal/tender-participation/:tenderId/lots/:lotId',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.USER, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.CLIENT}
      >
        <TenderParticipationLotPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/management-dashboard',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.PROCUREMENT_SPECIALIST, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <ManagementDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/tender-committee',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.USER, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <TenderCommittee />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/procurement-committee',
    element: (
      <ProtectedRoute
        roles={[
          EUserRoles.USER,
          EUserRoles.COMMITTEE_MEMBER,
          EUserRoles.SUPER_ADMIN,
        ]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <ProcurementCommittee />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/tender-committee/details/:tenderId',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.USER, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <CommissionEvaluationDetailsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/procurement-committee/details/:tenderId/:committeeEvaluationId',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.USER, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <CommitteeEvaluationDetailsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/notifications',
    element: <Notification />,
  },
  {
    path: '/portal/video-instruction',
    element: (
      <ProtectedRoute
        roles={[
          EUserRoles.ADMIN,
          EUserRoles.COMMISSION_MEMBER,
          EUserRoles.SUPER_ADMIN,
        ]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <VideoInstructions />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/faq',
    element: (
      <ProtectedRoute
        roles={[
          EUserRoles.ADMIN,
          EUserRoles.COMMISSION_MEMBER,
          EUserRoles.SUPER_ADMIN,
        ]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <FaqPortal />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/reports',
    element: (
      <ProtectedRoute
        roles={[
          EUserRoles.ADMIN,
          EUserRoles.COMMISSION_MEMBER,
          EUserRoles.SUPER_ADMIN,
        ]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <ReportsPortal />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/news',
    element: (
      <ProtectedRoute
        roles={[
          EUserRoles.ADMIN,
          EUserRoles.COMMISSION_MEMBER,
          EUserRoles.SUPER_ADMIN,
        ]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <NewsPortal />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/organizations',
    element: (
      <ProtectedRoute
        roles={[EUserRoles.ADMIN, EUserRoles.SUPER_ADMIN]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <Organizations />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/news/create',
    element: (
      <ProtectedRoute
        roles={[
          EUserRoles.ADMIN,
          EUserRoles.COMMISSION_MEMBER,
          EUserRoles.SUPER_ADMIN,
        ]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <CreateEditNews />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/news/edit/:id',
    element: (
      <ProtectedRoute
        roles={[
          EUserRoles.ADMIN,
          EUserRoles.COMMISSION_MEMBER,
          EUserRoles.SUPER_ADMIN,
        ]}
        orgType={EOrganizationType.TENDER_AUTHORITY}
      >
        <CreateEditNews />
      </ProtectedRoute>
    ),
  },
  {
    path: '/portal/settings',
    element: <Settings />,
  },
  //TODO. This route is for testing purposes. Remove after we done with it
  {
    path: '/azericard',
    element: <AzeriCard />,
  },
])
